import { inject } from '@angular/core';
import { RedirectCommand, ResolveFn, Router } from '@angular/router';
import { firstValueFrom } from 'rxjs';

import { User } from '@models';
import { UserBeanService, UserService } from '@services';

export const usersResolver: ResolveFn<Nullable<User>> = async () => {
  const userBeanService = inject(UserBeanService);
  const userService = inject(UserService);
  const router = inject(Router);

  const userBean = await userBeanService.getUserBean();

  if (userBean.rootUsersPermission > 3) {
    return firstValueFrom(userService.getUser(userBean.rootUsersId));
  }

  return new RedirectCommand(router.parseUrl('/home'));
};
